var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgGridSmall = function SvgGridSmall(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.6 10.6H4.9V4.9h5.7zM6.1 9.4h3.3V6.1H6.1zm13 1.2h-5.7V4.9h5.7zm-4.5-1.2h3.3V6.1h-3.3zm4.5 9.7h-5.7v-5.7h5.7zm-4.5-1.2h3.3v-3.3h-3.3zm-4 1.2H4.9v-5.7h5.7zm-4.5-1.2h3.3v-3.3H6.1z"
  })));
};
export { SvgGridSmall as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3e%3cpath fill='currentColor' d='M10.6 10.6H4.9V4.9h5.7zM6.1 9.4h3.3V6.1H6.1zm13 1.2h-5.7V4.9h5.7zm-4.5-1.2h3.3V6.1h-3.3zm4.5 9.7h-5.7v-5.7h5.7zm-4.5-1.2h3.3v-3.3h-3.3zm-4 1.2H4.9v-5.7h5.7zm-4.5-1.2h3.3v-3.3H6.1z'/%3e%3c/svg%3e";